
import * as Sentry from '@sentry/browser';
import isSupportBrowser from './common/utils/isSupportBrowser';
import isSupportOs from './common/utils/isSupportOs';
const isSendable = isSupportBrowser && isSupportOs();

Sentry.init({
  dsn: 'https://7f764413adb346528e201f015f662b5f@o350944.ingest.sentry.io/5214469',
  environment: 'production',
  ignoreErrors: [
    /Request failed with status code/,
    /Object expected/,
    /Network Error/,
    /無効/, // 無効な引数です, 引数が無効です
    /ResizeObserver loop limit exceeded/,
    /Network request failed/,
    /Cannot set property '.*' of undefined/,
    /Object expected/,
    /undefined is not an object/,
    `NotAllowedError: The request is not allowed by the user agent or the platform in the current context, possibly because the user denied permission.`,
    /NotSupportedError/,
    /removeAllHighlightsForSB/,
    'window.onorientationchange is not a function',
    'AbortError: The operation was aborted.'
  ],
  beforeSend(event) {
    if (!isSendable) {
      return null;
    }
    return event;
  }
});

window.Sentry = Sentry;

